import { Section, WordCycle } from "./Primitives";
import { FadeUp } from "./Reveal";
import { TICKER_2 } from "../../data/content";

export function Ticker2() {
  return (
    <Section id="ticker-2" className="py-28 md:py-44">
      <FadeUp>
        <h2 className="mx-auto max-w-5xl text-center font-display text-[2.3rem] font-light leading-[1.12] tracking-[-0.015em] text-content sm:text-5xl md:text-6xl">
          {TICKER_2.pre}{" "}
          <WordCycle words={TICKER_2.words} interval={2200} />{" "}
          {TICKER_2.post}
          <br />
          <span className="text-mutedc">{TICKER_2.punch}</span>
        </h2>
      </FadeUp>
    </Section>
  );
}
